import { compact } from '../../../../helpers/compact';
import {
  HeaderSlice,
  LaPosteEn4SliceType,
} from '../../../../types/page/la-poste-en-4';
import { toImage, toLink, toRichText, toText } from '../../fields';

const headerSlice = (data: Record<string, any>): HeaderSlice | undefined => {
  const image = toImage(data.primary?.image);
  const description = toRichText(data.primary?.description);
  if (!image || !description) {
    return undefined;
  }

  return compact({
    type: LaPosteEn4SliceType.HEADER,
    image,
    description,
    ctaLabel: toText(data.primary?.ctaLabel),
    ctaLink: toLink(data.primary?.ctaLink),
  });
};

export default headerSlice;
